import styled from 'styled-components';

import { body } from '@constants/fonts';

export const FormOuterDiv = styled.div`
  width: 90%;
  margin: 15px;
`;

export const Title = styled.h1`
  width: 90%;
  text-align: center;
`;

export const LoginError = styled.div`
  color: ${({ theme }) => theme.palette.secondary.main};
  width: 100%;
  text-align: center;
`;

export const ClientNumber = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const PresetBox = styled.p`
  height: 47px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 7px;
  background-color: ${({ theme }) => theme.palette.common.accentLightblue};
  display: flex;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
  user-select: none;
  align-self: flex-start;
  font-weight: bold;
`;

export const FakeLabel = styled.label`
  height: 22px;
  width: 100%;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 16px;
  line-height: 22px;
  margin: 0 8px;
  box-sizing: border-box;
  font-family: ${body};
`;

export const DashSeparator = styled.p`
  font-weight: bold;
  padding: 0 2px;

  &:after {
    content: '-';
  }
`;

export const OuterContainerFlex = styled.div`
  display: flex;
  justify-content: center;
`;

export const ContainerCenter = styled.div`
  margin: 0 auto;
  width: 50%;
  max-width: 1080px;
  display: flex;
  align-items: center;
  flex-direction: column;
  height: max-content;
  padding-top: 10px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 100% !important;
  }
`;
